module.exports = function getResource(label, vars = []) {
    const resources = {
        multiLocation: 'Multiple other times and locations',
        otherLocations: `${vars[0]} other locations`,
        virtual: 'Virtual'
    };

    return resources[label];
};
